import type { CSSProperties } from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import './BayBreadcrumbs.scss';

interface BreadcrumbItem {
	label: string;
	[key: string]: any;
}

interface BayBreadcrumbsProps {
	breadcrumbs?: BreadcrumbItem[];
	onSelect?: (data: BreadcrumbItem, breadcrumbs: BreadcrumbItem[]) => void;
	breadcrumbItemStyles?: CSSProperties;
}

const BayBreadcrumbs = ({
	breadcrumbs,
	onSelect = () => {},
	breadcrumbItemStyles,
}: BayBreadcrumbsProps) => {
	const onCrumbSelect = (data: BreadcrumbItem, index: number) => {
		onSelect(data, breadcrumbs?.slice(0, index + 1) ?? []);
	};

	return (
		<div className="bay-breadcrumbs">
			<Breadcrumb>
				{breadcrumbs?.map((crumb, index) => {
					const isActive =
						breadcrumbs?.length - 1 === index || breadcrumbs?.length === 1;
					return (
						<Breadcrumb.Item
							key={index}
							active={isActive}
							as="li"
							onClick={() => {
								if (!isActive) {
									onCrumbSelect(crumb, index);
								}
							}}
						>
							<div
								className="d-flex"
								style={
									breadcrumbItemStyles
										? breadcrumbItemStyles
										: { fontSize: '16px', fontWeight: '600' }
								}
							>
								{index !== 0 && (
									<div className="py-2">
										<svg
											fill="var(--bs-gray-700)"
											height="15"
											viewBox="0 0 16 16"
											width="15"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												clipRule="evenodd"
												d="M4.64645 1.64645C4.84171 1.45118 5.15829 1.45118 5.35355 1.64645L11.3536 7.64645C11.5488 7.84171 11.5488 8.15829 11.3536 8.35355L5.35355 14.3536C5.15829 14.5488 4.84171 14.5488 4.64645 14.3536C4.45118 14.1583 4.45118 13.8417 4.64645 13.6464L10.2929 8L4.64645 2.35355C4.45118 2.15829 4.45118 1.84171 4.64645 1.64645Z"
												fillRule="evenodd"
											/>
										</svg>
									</div>
								)}
								<span className="breadItem px-2 py-2">{crumb?.label}</span>
							</div>
						</Breadcrumb.Item>
					);
				})}
			</Breadcrumb>
		</div>
	);
};

export default BayBreadcrumbs;
